<div class="ui-kit-playground">
  <h3 class="ui-kit-playground__title">Time input field</h3>

  <div class="ui-kit-playground__controls">
    <label class="ui-kit-playground__control ui-kit-playground__control--checkbox">
      <input type="checkbox" [formControl]="form.get('disabled')" />
      <span class="ui-kit-playground__label">Disabled</span>
    </label>
  </div>

  <div class="ui-kit-playground__preview" [formGroup]="form">
    <app-time-input-field
      formControlName="from"
      label="Desde"
      [required]="true"
      [disabled]="disabled"
    ></app-time-input-field>
    <app-time-input-field
      formControlName="to"
      label="Hasta"
      [disabled]="disabled"
    ></app-time-input-field>

    <p class="ui-kit-playground__value">
      <strong>Desde:</strong> {{ form.get('from')?.value }}
    </p>
    <p class="ui-kit-playground__value">
      <strong>Hasta:</strong> {{ form.get('to')?.value }}
    </p>
  </div>
</div>
